// Always use same-origin for API requests in the browser.
// In local development, Create React App's "proxy" setting
// (in package.json) will forward /api requests to the Node server.
export const apiUrl = (path: string): string => path;


